import React from 'react';
import * as styles from './AdminBetaView.module.scss';
import Button from '../../components/Button';
import { Cards } from '../../components/Card';
import FormField from '../../components/formInternals/FormField';
import SVGIcon from '../../components/SVGIcon';
import checkBoldIcon from '../../icons/non-prefilled/16x16/checkBold.svg';
import SettingCard from '../../settings/SettingCard';
import SettingsContainerView from '../../settings/SettingsContainerView';
import SettingsSection from '../../settings/SettingsSection';
import Link from '../../utils/router/Link';

const FEATURES_MOCK = [
  {
    id: '1',
    title: 'Features #1',
    description: (
      <>
        Workbench is the new home for developers to access your integration{' '}
        <Link to="/admin/beta">health, logs, errors, and webhooks.</Link>
      </>
    ),
    requested: true,
    active: true,
  },
  {
    id: '2',
    title: 'Features #2',
    description: (
      <>
        Workbench is the new home for developers{' '}
        <Link to="/admin/beta">to access your integration</Link> health, logs,
        errors, and webhooks.
      </>
    ),
    requested: false,
    active: false,
  },
];

const AdminBetaView = () => {
  return (
    <SettingsContainerView
      className={styles.container}
      title="Beta features"
      subtitle={
        <div className={styles.description}>
          Try out upcoming features and share feedback before they are released.
          Some betas have waitlists but share your use cases to be approved
          sooner!
        </div>
      }
    >
      <SettingsSection header="Waitlist">
        <Cards>
          {FEATURES_MOCK.map((feature) => (
            <SettingCard
              key={feature.id}
              title={feature.title}
              description={
                <div className={styles.cardDescription}>
                  {feature.description}
                </div>
              }
              actions={
                feature.requested ? (
                  <div className={styles.requested}>
                    <SVGIcon>{checkBoldIcon}</SVGIcon>Requested
                  </div>
                ) : (
                  <Button variant="secondary" onClick={() => {}}>
                    Request
                  </Button>
                )
              }
            />
          ))}
        </Cards>
      </SettingsSection>
      <SettingsSection header="Available">
        <Cards>
          {FEATURES_MOCK.map((feature) => (
            <SettingCard
              key={feature.id}
              title={feature.title}
              description={
                <div className={styles.cardDescription}>
                  {feature.description}
                </div>
              }
              actions={
                <FormField
                  type="checkbox"
                  toggle
                  name="tier"
                  margin="none"
                  onChange={() => {}}
                  checked={feature.active}
                />
              }
            />
          ))}
        </Cards>
      </SettingsSection>
      <SettingsSection header="Released">
        <Cards>
          {FEATURES_MOCK.map((feature) => (
            <SettingCard
              key={feature.id}
              title={feature.title}
              description={
                <div className={styles.cardDescription}>
                  {feature.description}
                </div>
              }
              actions={
                <Button variant="secondary" onClick={() => {}}>
                  Open
                </Button>
              }
            />
          ))}
        </Cards>
      </SettingsSection>
    </SettingsContainerView>
  );
};

export default AdminBetaView;
